export const isLocalStorageAvailable = () => {
  let test = "test";
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

export const isSessionStorageAvailable = () => {
  let test = "test";
  try {
    sessionStorage.setItem(test, test);
    sessionStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

export const isIndexedDBAvailable = () => {
  return !!window.indexedDB;
};
